module.exports = __webpack_public_path__ + "img/logo-v2.0393bb0f.png";